import { fromJS } from 'immutable';

const initialState = fromJS({
	data: {},
	failure: '',
	isLoading: false
});

export default (state = initialState, action: any) => {
	switch (action.type) {
		default:
			return state;
	}
};
